import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { CommentContext, CommentContextProvider } from '../../CommentContext';
import LoadableCommentReduxModule from '../../redux/LoadableCommentReduxModule';
var View;
(function (View) {
    /** The current user is editing one of their own comments. */
    View["Editing"] = "editing";
    /** The comment has been marked as spam. */
    View["Spam"] = "spam";
    /** The comment is hidden for some reason. Likely moderation */
    View["Hidden"] = "hidden";
    /** Shown when the comment has been orphaned */
    View["Orphan"] = "orphan";
    /** The usual view when nothing is wrong with the comment and the user isn't editing it. */
    View["Read"] = "read";
})(View || (View = {}));
/** Checks a couple flags and spits out the current view we should show for a comment. */
function getCommentView(_a) {
    var comment = _a.comment, isEditing = _a.isEditing, isPeeking = _a.isPeeking;
    var isSpam = comment.isSpam, isHidden = comment.isHidden, isDeleted = comment.isDeleted, isAdminHidden = comment.isAdminHidden, replies = comment.replies;
    var isVisible = !isAdminHidden && !isDeleted;
    if (isEditing) {
        return View.Editing;
    }
    else if (!isPeeking && isSpam && replies !== 0) {
        return View.Spam;
    }
    else if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
        return View.Hidden;
    }
    else if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return View.Orphan;
    }
    else {
        return View.Read;
    }
}
var CommentSkeletonViewSwitcher = function (_a) {
    var editingView = _a.editingView, spamView = _a.spamView, hiddenView = _a.hiddenView, orphanView = _a.orphanView, readView = _a.readView;
    var comment = useContext(CommentContext).comment;
    var _b = useContext(CommentContext), isEditing = _b.isEditing, isPeeking = _b.isPeeking;
    var view = getCommentView({ comment: comment, isPeeking: isPeeking, isEditing: isEditing });
    switch (view) {
        // Fragments here because typescript complains otherwise.
        case View.Editing:
            return React.createElement(React.Fragment, null, editingView);
        case View.Spam:
            return React.createElement(React.Fragment, null, spamView);
        case View.Hidden:
            return React.createElement(React.Fragment, null, hiddenView);
        case View.Orphan:
            return React.createElement(React.Fragment, null, orphanView);
        case View.Read:
            return React.createElement(React.Fragment, null, readView);
        default:
            return null;
    }
};
CommentSkeletonViewSwitcher.displayName = 'CommentSkeletonViewSwitcher';
/** A skeleton for the various views that a comment preset needs to implement. */
var CommentSkeleton = function (_a) {
    var comment = _a.comment, className = _a.className, onEditingStateChange = _a.onEditingStateChange, rest = __rest(_a, ["comment", "className", "onEditingStateChange"]);
    return (React.createElement(CommentContextProvider, { comment: comment, onEditingStateChange: onEditingStateChange },
        React.createElement(LoadableCommentReduxModule, null),
        React.createElement("div", { className: className },
            React.createElement(CommentSkeletonViewSwitcher, __assign({}, rest)))));
};
CommentSkeleton.displayName = 'CommentSkeleton';
export default CommentSkeleton;
//# sourceMappingURL=CommentSkeleton.js.map